import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { Grid } from "@mui/material"
import PageWrapper from "Pages/@PageWrapper"
import { EUROPCAR_ROUTES } from "@constants/routes"
import EuropcarPricingEnvironmentFilters from "./Filters"
import EuropcarPricingEnvironmentTable from "./Table"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import PricingEnvironmentDemoData from "./VirtualTour/DemoData"
import { resetPricingEnvFilters } from "./@signals"


export default function EuropcarPricingEnvironmentPage() {
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		resetPricingEnvFilters()
		return () => {
			resetPricingEnvFilters()
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${EUROPCAR_ROUTES.TITLE}`}
		title={EUROPCAR_ROUTES.TITLE}
		subtitle={EUROPCAR_ROUTES.PRICING_ENV_SUBTITLE}
		isEmpty={false}
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<EuropcarPricingEnvironmentFilters />
			</Grid>
			<EuropcarPricingEnvironmentTable />
		</Grid>
		{tourActive && <PricingEnvironmentDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
